var map = {
	"./AMEX_LOCAL.svg": "2666",
	"./CUP_LOCAL.svg": "9da6",
	"./DCI_LOCAL.svg": "1637",
	"./DXNEXTPAY.svg": "2035",
	"./JCB_LOCAL.svg": "3e56",
	"./MASTER_LOCAL.svg": "2ad8",
	"./NAPASCREDIT.svg": "7538",
	"./UNIONPAY.svg": "97ee",
	"./VISA_LOCAL.svg": "6fbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a3a";